import { render, staticRenderFns } from "./CapacitySection.vue?vue&type=template&id=49c6334f&scoped=true&"
import script from "./CapacitySection.vue?vue&type=script&lang=js&"
export * from "./CapacitySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c6334f",
  null
  
)

export default component.exports